/**
 * Utilidades de archivos genéricas (independientes del dominio).
 *
 * Vivían originalmente en `pages/documents/docHelper.ts` pero son agnósticas
 * de documents. `docHelper.ts` las re-exporta para no romper imports existentes.
 */

/** Obtiene la extensión del archivo (e.g., ".pdf", ".docx"). */
export const getFileExtension = (filename: string): string => {
  const match = filename.match(/\.[^/.]+$/)
  return match ? match[0] : ''
}

/** Remueve la extensión del nombre del archivo. */
export const removeExtension = (filename: string): string => {
  return filename.replace(/\.[^/.]+$/, '')
}

/**
 * Formatea el nombre del archivo para almacenamiento:
 * minúsculas, espacios → `_`, sin caracteres especiales, sin `_` consecutivos.
 */
export const formatFileName = (name: string): string => {
  return name
    .toLowerCase()
    .trim()
    .replace(/\s+/g, '_')
    .replace(/[^a-z0-9_.-]/g, '')
    .replace(/_+/g, '_')
    .replace(/^_+|_+$/g, '')
}

/**
 * Formatea el tamaño del archivo a unidades legibles.
 * @param bytes - Tamaño en bytes.
 * @returns String formateado (e.g., "2.50MB", "512KB", "1024B").
 */
export const formatFileSize = (bytes: number): string => {
  if (bytes < 1024) return `${bytes}B`
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(2)}KB`
  return `${(bytes / (1024 * 1024)).toFixed(2)}MB`
}
